{
  "Programcı": "Programmeur",
  "menu": {
    "Admin": "Beheerder",
    "Href": "Href",
    "Menü Düzenle": "Menu Bewerken",
    "Menü Yönetimi": "Menubeheer",
    "Programcı": "Programmeur",
    "Silmek istediğinize emin misiniz? Alt menüler de silinecektir": "Weet u zeker dat u wilt verwijderen? Submenu's worden ook verwijderd.",
    "Sıralamayı Kaydet": "Volgorde Opslaan",
    "Virgül ile ayırın": "Scheiden met komma's",
    "Yeni Menü Ekle": "Nieuw Menu Toevoegen",
    "Yetki Ayarları": "Rechten Instellingen",
    "Yetki Kodları (Örn: 101002, 102002)": "Rechten Codes (Bijv: 101002, 102002)",
    "JSON format hatası: ": "JSON format hatası: ",
    "Yeni Menü": "Yeni Menü",
    "edit": "edit",
    "delete": "delete"
  }
}
